let stack = []
let listeners = []

export const getStack = () => stack

export const subscribe = (listener) => {
  listeners.push(listener)
  return () => {
    listeners = listeners.filter((l) => l !== listener)
  }
}

const notify = () => listeners.forEach((listener) => listener(stack))

// Renders `Component` with isOpen/onRequestClose wired automatically, so any
// component shaped like pages/vendor/OrderDetailsBar/AddressModal.js (takes
// isOpen/onRequestClose, owns its own <Modal>) can be shown from anywhere,
// without each caller holding its own open/close state:
//   showModal(AddressModal, { initialAddress, onSave })
//
// Stacks rather than replaces, so a modal can open another on top of itself
// (e.g. DateTimeModal opening DatePickerModal) without losing its own state
// underneath — hideModal() closes only the top of the stack.
//
// A component already on the stack isn't added again. Several places ask for
// the same modal (the delivery address prompt fires when the order details bar
// mounts, on the review page, and on a menu item click), and each copy adds
// another translucent overlay until the page behind turns black.
export const showModal = (Component, props = {}) => {
  if (stack.some((entry) => entry.Component === Component)) return
  stack = [...stack, { Component, props }]
  notify()
}

export const hideModal = () => {
  stack = stack.slice(0, -1)
  notify()
}
